<template>
  <vue-modal classes="vue-modal-container"
             height="auto"
             name="sign-up-modal"
             width="300px">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('sign-up-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content">
      <div class="ui form">
        <div class="field">
          <label>{{ trans.fullName }}
            <input v-model="userName"
                   :placeholder="trans.fullNamePlaceholder"
                   type="text"
                   @keyup.enter="signUp">
          </label>
        </div>
        <div class="field">
          <label>{{ trans.email }}
            <input v-model="userEmail"
                   :placeholder="trans.emailPlaceholder"
                   type="email"
                   @keyup.enter="signUp">
          </label>
        </div>
        <div class="field">
          <label>{{ trans.pwd }}
            <input v-model="userPwdOne"
                   type="password"
                   @keyup.enter="signUp">
          </label>
        </div>
        <div class="field">
          <label>{{ trans.pwdAgain }}
            <input v-model="userPwdTwo"
                   type="password"
                   @keyup.enter="signUp">
          </label>
        </div>
        <div class="field">
          <div class="ui checkbox">
            <input id="aszfConfirm"
                   v-model="confirmAszf"
                   type="checkbox">
            <label for="aszfConfirm"><a class="aszf-modal-button"
                                        @click="showAszfModal()">{{ trans.privacyPolicyPartOne }}</a>
              {{ trans.privacyPolicyPartTwo }}</label>
          </div>
        </div>
        <div class="row collapse">
          <div class="small-12 medium-12 columns sign-up-btn-container">
            <button class="ui primary button"
                    @click="signUp">{{ trans.signUpBtn }}
            </button>
          </div>
          <!--
          <div class="small-6 medium-6 columns">
            <button class="ui facebook button"
                    @click="facebookClick">
              <i class="facebook icon"></i>
              Facebook
            </button>
          </div>
          <div class="small-6 medium-6 columns">
            <button class="ui google plus button"
                    @click="googleClick">
              <i class="google plus icon"></i>
              Google
            </button>
          </div>
          -->
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import sha1 from 'js-sha1'
import notify from '../../notify'
import config from '@/config'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      userName: null,
      userEmail: null,
      userPwdOne: null,
      userPwdTwo: null,
      confirmAszf: false,
      googleLoginUrl: config.GOOGLE_LOGIN_URL,
      facebookLoginUrl: config.FACEBOOK_LOGIN_URL,
    }
  },
  methods: {
    signUp () {
      let name = this.userName
      let email = this.userEmail
      let pwd = this.userPwdOne
      let pwd2 = this.userPwdTwo
      if (name === null || name === '') {
        notify.warning('A név megadása kötelező')
      } else {
        if (!isEmailValid(email)) {
          notify.warning('Az email-cím megadása kötelező')
        } else {
          if (!isPasswordMatch(pwd, pwd2)) {
            notify.warning('A jelszavak nem egyeznek!')
          } else {
            if (!isPasswordValid(pwd, pwd2)) {
              notify.warning('A jelszónak minimum 6 karakterből kell állnia!')
            } else {
              if (!this.confirmAszf) {
                notify.warning('A regisztrációhoz el kell fogadnod az Adatkezelési irányelveinket')
              } else {
                // all data is valid, start sign up
                let userData = {
                  name: this.userName,
                  email: this.userEmail,
                  password: sha1(this.userPwdOne),
                }
                this.$emit('sign-up', userData)
              }
            }
          }
        }
      }
    },
    showAszfModal () {
      // eslint-disable-next-line
      this.$modal.show('aszf-modal')
    },
    facebookClick () {
      location.href = this.facebookLoginUrl
    },
    googleClick () {
      location.href = this.googleLoginUrl
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.signUpModal,
    }),
  },
}

function isEmailValid (email) {
  /* eslint-disable */
  let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regExp.test(email)
}

function isPasswordMatch (pwd, pwd2) {
  if (pwd && pwd2) {
    return pwd === pwd2
  } else {
    return false
  }

}

function isPasswordValid (pwd, pwd2) {
  if (pwd && pwd2) {
    return pwd.length >= 6
  } else {
    return false
  }
}

</script>

<style scoped>
.button {
  width: 100%;
}

.sign-up-btn-container {
  margin-bottom: 0.5rem;
}

.aszf-modal-button {
  cursor: pointer;
}
</style>
